import styled from '@emotion/styled';
import GuestForm from '@view/components/GuestForm';
import { Box, Divider } from '@chakra-ui/react';
import { useStore } from '@data/other/withStore';
import { observer } from 'mobx-react';
import ShoppingCart from '@view/components/Cards/ShoppingCart';
import { Routes as AppRoutes } from '@view/routes';
import ScreenSize from '@view/constants/screen-sizes';
import Card from '@molecules/Card';
import useForm from '@molecules/FormFactory/useForm';
import { Guest } from '@data/models';
import { usePageNavigation } from '@view/hooks/usePageNavigation';
import { SessionTitle } from '@view/components/SessionTitle';

const GuestPage = () => {
  const {
    property: { guests },
  } = useStore();

  const { goTo } = usePageNavigation();

  const useFormResult = useForm(async (data: Guest) => {
    guests.updateMainGuest(data);
    goTo(AppRoutes.Payment, AppRoutes.AddGuest);
  });

  const { onSave } = useFormResult;

  return (
    <StyledWrapper>
      <Card>
        <SessionTitle page={AppRoutes.AddGuest} title={'Add Guests'} />
        <StyledTitle>Add primary and additional guests</StyledTitle>
        <GuestForm defaultValues={guests.main} useFormResult={useFormResult} />
        <Divider my="32px" />
        {/* <AdditionalGuests onClickAdd={onClickAdd} onClickRemove={onClickRemove} /> */}
      </Card>
      <StyledSideComponent>
        <ShoppingCart path={AppRoutes.AddGuest} onOk={onSave} />
      </StyledSideComponent>
    </StyledWrapper>
  );
};

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    flex-direction: column;
  }
`;

const StyledTitle = styled.p`
  padding-bottom: 16px;
`;

const StyledSideComponent = styled(Box)`

  position: relative;
  display:flex;
  flex-direction: column;

  width: 340px;
  min-width: 340px;
  margin-left: 40px;
  
  @media screen and (max-width: ${ScreenSize.MOBILE_LARGE}) {
    width: 100%;
    margin-left: unset;
  }
`;

export default observer(GuestPage);
